// English Translations
export const en = {
  // Common
  common: {
    save: 'Save & Print',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    filter: 'Filter',
    all: 'All',
    yes: 'Yes',
    no: 'No',
    ok: 'OK',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    loading: 'Loading...',
    noData: 'No data available',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Info',
    today: 'Today',
    week: 'Week',
    month: 'Month',
    year: 'Year',
    custom: 'Custom',
    thisWeek: 'This Week',
    thisMonth: 'This Month',
    thisQuarter: 'This Quarter',
    thisYear: 'This Year',
    from: 'From',
    to: 'To',
    date: 'Date',
    time: 'Time',
    amount: 'Amount',
    cart: 'Cart',
    total: 'Total',
    subtotal: 'Subtotal',
    discount: 'Discount',
    tax: 'Tax',
    quantity: 'Quantity',
    price: 'Price',
    unit: 'Unit',
    description: 'Description',
    notes: 'Notes',
    status: 'Status',
    actions: 'Actions',
    staff: 'Staff',
    view: 'View',
    print: 'Print',
    download: 'Download',
    share: 'Share',
    export: 'Export',
    import: 'Import',
    refresh: 'Refresh',
    reset: 'Reset',
    clear: 'Clear',
    select: 'Select',
    selected: 'Selected',
    required: 'Required',
    optional: 'Optional',
    online: 'Online',
    offline: 'Offline',
    attach: 'Attach',
    image: 'Image',
    document: 'Document',
    payment: 'Payment',
    paid: 'Paid',
    pending: 'Pending',
    cash: 'Cash',
    bank: 'Bank',
    card: 'Card',
    upi: 'UPI',
    cheque: 'Cheque',
  },

  // Navigation
  nav: {
    dashboard: 'Dashboard',
    sales: 'Sales',
    pos: 'POS',
    purchases: 'Purchases',
    quotations: 'Quotations',
    parties: 'Parties',
    expenses: 'Expenses',
    inventory: 'Inventory',
    reports: 'Reports',
    banking: 'Banking',
    utilities: 'Utilities',
    others: 'Others',
    userManagement: 'User Management',
    settings: 'Settings',
    companyInfo: 'Company Info',
    logout: 'Logout',
    billing: 'Billing',
    more: 'More',
    premiumFeatures: 'Premium Features',
    unlockAdvanced: 'Unlock advanced reports and analytics',
    upgradeNow: 'Upgrade Now',
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    welcome: 'Welcome',
    todaySales: "Today's Sales",
    totalRevenue: 'Total Revenue',
    totalExpenses: 'Total Expenses',
    netProfit: 'Net Profit',
    pendingPayments: 'Pending Payments',
    lowStock: 'Low Stock Items',
    recentActivity: 'Recent Activity',
    quickActions: 'Quick Actions',
    topCustomers: 'Top Customers',
    topSellingItems: 'Top Selling Items',
    salesOverview: 'Sales Overview',
    quickInsight: 'Quick Insight',
    aiScan: 'AI Scan',
    aiSale: 'AI Sale',
    aiBill: 'AI Bill',
    scanBill: 'Scan Bill',
    startChat: 'Start Chat',
    viewAll: 'View All',
    seeAll: 'See All',
  },

  // Sales
  sales: {
    title: 'Sales',
    newSale: 'New Sale',
    addSale: 'Add Sale',
    salesInvoices: 'Sales Invoices',
    invoices: 'invoices',
    invoice: 'Invoice',
    invoiceNumber: 'Invoice Number',
    invoiceDate: 'Invoice Date',
    customer: 'Customer',
    customerName: 'Customer Name',
    customerPhone: 'Customer Phone',
    searchCustomer: 'Search customer...',
    searchItem: 'Search & add item...',
    addItem: 'Add Item',
    itemName: 'Item Name',
    qty: 'Qty',
    rate: 'Rate',
    mrp: 'MRP',
    taxable: 'Taxable',
    discPercent: 'Disc%',
    discAmount: 'Disc₹',
    gstPercent: 'GST%',
    gstAmount: 'GST₹',
    cgst: 'CGST',
    sgst: 'SGST',
    igst: 'IGST',
    taxMode: 'Tax Mode',
    withGst: 'With GST',
    withoutGst: 'Without GST',
    inclusive: 'Inclusive',
    exclusive: 'Exclusive',
    saveAndPrint: 'Save & Print',
    saveDraft: 'Save Draft',
    preview: 'Preview',
    recordPayment: 'Record Payment',
    paymentReceived: 'Payment Received',
    paymentPending: 'Payment Pending',
    paid: 'Paid',
    pending: 'Pending',
    partial: 'Partial',
    credit: 'Credit',
    cash: 'Cash',
    bank: 'Bank',
    upi: 'UPI',
    card: 'Card',
    cheque: 'Cheque',
    mixed: 'Mixed',
    noPay: 'No Pay',
    balanceDue: 'Balance Due',
    dueDate: 'Due Date',
    due: 'Due',
    received: 'Received',
    collected: 'Collected',
    pos: 'POS',
    cafe: 'CAFÉ',
    sNo: 'S.No',
    hsnCode: 'HSN Code',
    roundOff: 'Round Off',
    vehicleNo: 'Vehicle No',
    duplicateInvoice: 'Duplicate Invoice',
    deleteInvoice: 'Delete Invoice',
    whatsappReminder: 'WhatsApp Reminder',
    scanBarcode: 'Scan Barcode',
    grandTotal: 'Grand Total',
    createBill: 'Create Bill',
    items: 'items',
    totalItems: 'Total Items',
    paidAmount: 'Paid',
    balance: 'Balance',
    walkInCustomer: 'Walk-in Customer',
    payment: 'Payment',
    selectCustomer: 'Select Customer',
    newBill: 'New Bill',
    completeSale: 'Complete Sale',
    billComplete: 'Bill Complete',
    startNewBill: 'Start New Bill',
    shareReceipt: 'Share Receipt',
    printReceipt: 'Print Receipt',
  },

  // POS (Point of Sale)
  posPage: {
    searchItems: 'Search items... (or scan barcode)',
    back: 'Back',
    all: 'All',
    customer: 'Customer',
    items: 'items',
    searchCustomer: 'Search customer...',
    new: 'New',
    walkIn: 'Walk-in',
    cartEmpty: 'Cart is empty',
    tapToAdd: 'Tap items to add',
    online: 'Online',
    offline: 'Offline',
    quickCheckout: 'Quick Checkout',
    total: 'Total',
    pay: 'Pay',
    holdBill: 'Hold Bill',
    clearCart: 'Clear Cart',
    discount: 'Discount',
    addCustomer: 'Add Customer',
    selectCustomer: 'Select Customer',
    noCustomerSelected: 'No customer selected',
    customerAdded: 'Customer added',
    billSaved: 'Bill saved successfully',
    billCompleted: 'Bill completed',
    paymentReceived: 'Payment received',
    change: 'Change',
    printReceipt: 'Print Receipt',
    shareReceipt: 'Share Receipt',
    newBill: 'New Bill',
    holdOrders: 'Hold Orders',
    noHoldOrders: 'No hold orders',
    restoreBill: 'Restore Bill',
    deleteBill: 'Delete Bill',
    qty: 'Qty',
    price: 'Price',
    subtotal: 'Subtotal',
    tax: 'Tax',
    grandTotal: 'Grand Total',
    cash: 'Cash',
    card: 'Card',
    upi: 'UPI',
    mixed: 'Mixed',
    enterAmount: 'Enter amount',
    amountDue: 'Amount Due',
    amountPaid: 'Amount Paid',
    balanceDue: 'Balance Due',
    completeSale: 'Complete Sale',
    cancelSale: 'Cancel Sale',
    addNote: 'Add Note',
    removeItem: 'Remove Item',
    increaseQty: 'Increase Quantity',
    decreaseQty: 'Decrease Quantity',
    outOfStock: 'Out of Stock',
    lowStock: 'Low Stock',
    inStock: 'In Stock',
    syncing: 'Syncing...',
    pending: 'pending',
    connected: 'Connected',
    allFeaturesAvailable: 'All features available',
    workingLocally: 'Working locally',
    pendingChanges: 'Pending Changes',
    lastSynced: 'Last Synced',
    syncNow: 'Sync Now',
    allChangesSynced: 'All changes synced',
    offlineModeActive: 'Offline Mode Active',
    offlineModeInfo: 'You can continue creating sales, purchases, and other records. They will automatically sync when you\'re back online.',
    youreOffline: 'You\'re offline. Changes will sync when connected.',
    dismiss: 'Dismiss',
    never: 'Never',
    justNow: 'Just now',
  },

  // Purchases
  purchases: {
    title: 'Purchases',
    newPurchase: 'New Purchase',
    addPurchase: 'Add Purchase',
    purchaseInvoices: 'Purchase Invoices',
    supplier: 'Supplier',
    supplierName: 'Supplier Name',
    billNumber: 'Bill Number',
    billDate: 'Bill Date',
    purchaseOrder: 'Purchase Order',
    createNewBill: 'Create New Bill',
    editBill: 'Edit Bill',
    deleteBill: 'Delete Bill',
    duplicateBill: 'Duplicate Bill',
    downloadPDF: 'Download PDF',
    purchaseReturn: 'Purchase Return',
    supplierDetails: 'Supplier Details',
    searchSupplier: 'Search Supplier by name, phone, or email...',
    addNewSupplier: 'Add New Supplier',
    loadingSuppliers: 'Loading Suppliers...',
    noSuppliersFound: 'No Suppliers found',
    startTypingToSearch: 'Start typing to search...',
    clearSupplier: 'Clear & choose different Supplier',
    addItems: 'Add Items',
    searchAddItem: 'Search & add item...',
    noItemsAdded: 'No items added yet. Use search above or add a blank row.',
    discountPercent: 'Discount %',
    paymentMode: 'Payment Mode',
    notesOptional: 'Notes (Optional)',
    addNotes: 'Add any additional notes...',
    totalTax: 'Total Tax',
    billDetails: 'Bill Details',
    billTo: 'Bill To',
    deletePurchaseBill: 'Delete Purchase Bill?',
    deleteConfirmMessage: 'Are you sure you want to delete this bill? This action cannot be undone.',
    deleteWarning: 'Warning: Deleting this bill will affect your sales records and may impact your accounting reports.',
    phoneNumber: 'Phone Number',
    optionalInfo: 'Optional Information',
    billingAddress: 'Billing Address',
    enterBillingAddress: 'Enter billing address',
    selectState: 'Select State',
    gstNumber: 'GST Number',
    enterGstNumber: 'Enter GST number',
    emailAddress: 'Email Address',
    enterEmail: 'Enter email address',
    supplierType: 'Supplier Type',
    regular: 'Regular',
    wholesale: 'Wholesale',
    retail: 'Retail',
    distributor: 'Distributor',
    purchaseCostPrice: 'Purchase Cost Price',
    selectBankAccount: 'Select Bank Account',
    noBankAccounts: 'No bank accounts found. Please add bank accounts in the Banking module first.',
    paymentDate: 'Payment Date',
    referenceNumber: 'Reference Number (Optional)',
    transactionIdPlaceholder: 'Transaction ID, Cheque No, etc.',
    previousPayments: 'Previous Payments',
    recordPayment: 'Record Payment',
    vehicle: 'Vehicle',
  },

  // Quotations
  quotations: {
    title: 'Quotations',
    newQuotation: 'New Quotation',
    addQuotation: 'Add Quotation',
    quotationNumber: 'Quotation Number',
    validUntil: 'Valid Until',
    convertToInvoice: 'Convert to Invoice',
    sendQuotation: 'Send Quotation',
    createNewQuotation: 'Create New Quotation',
    editQuotation: 'Edit Quotation',
    deleteQuotation: 'Delete Quotation',
    duplicateQuotation: 'Duplicate Quotation',
    downloadPDF: 'Download PDF',
    customerDetails: 'Customer Details',
    searchCustomer: 'Search customer by name, phone, or email...',
    addNewCustomer: 'Add New Customer',
    loadingCustomers: 'Loading Customers...',
    noCustomersFound: 'No Customers found',
    startTypingToSearch: 'Start typing to search...',
    clearCustomer: 'Clear & choose different Customer',
    addItems: 'Add Items',
    searchAddItem: 'Search & add item...',
    noItemsAdded: 'No items added yet. Use search above or add a blank row.',
    discountPercent: 'Discount %',
    paymentMode: 'Payment Mode',
    notesOptional: 'Notes (Optional)',
    addNotes: 'Add any additional notes...',
    totalTax: 'Total Tax',
    quotationDetails: 'Quotation Details',
    invoiceDetails: 'Invoice Details',
    billTo: 'Bill To',
    deleteQuotationConfirm: 'Delete Quotation?',
    deleteConfirmMessage: 'Are you sure you want to delete this quotation? This action cannot be undone.',
    phoneNumber: 'Phone Number',
    optionalInfo: 'Optional Information',
    billingAddress: 'Billing Address',
    enterBillingAddress: 'Enter billing address',
    selectState: 'Select State',
    gstNumber: 'GST Number',
    enterGstNumber: 'Enter GST number',
    emailAddress: 'Email Address',
    enterEmail: 'Enter email address',
    customerType: 'Customer Type',
    regular: 'Regular',
    wholesale: 'Wholesale',
    retail: 'Retail',
    purchaseCostPrice: 'Purchase Cost Price',
    paymentType: 'Payment Type',
    // Table headers
    item: 'Item',
    qty: 'Qty',
    unit: 'Unit',
    pricePerUnit: 'Price/Unit',
    discPercent: 'Disc %',
    discAmt: 'Disc Amt',
    taxAmt: 'Tax Amt',
    amount: 'Amount',
    hsnCode: 'HSN',
    description: 'Description',
    showColumns: 'Show Columns',
    searchForItems: 'Search for items to add to invoice',
    searchAddItemBarcode: 'Search & add item by name or barcode...',
    generateBill: 'Generate Bill',
    saveAndNew: 'Save & New',
    printPreview: 'Print Preview',
    checkout: 'CHECKOUT',
    addItemsToSeeTotal: 'Add items to see totals',
    itemsCount: '{count} item(s)',
    backToList: 'Back to quotation list',
  },

  // Parties
  parties: {
    title: 'Parties',
    newParty: 'New Party',
    addParty: 'Add Party',
    partyName: 'Party Name',
    partyType: 'Party Type',
    customer: 'Customer',
    supplier: 'Supplier',
    both: 'Both',
    phone: 'Phone',
    email: 'Email',
    gstin: 'GSTIN',
    address: 'Address',
    state: 'State',
    openingBalance: 'Opening Balance',
    currentBalance: 'Current Balance',
    toReceive: 'To Receive',
    toPay: 'To Pay',
    statement: 'Statement',
  },

  // Expenses
  expenses: {
    title: 'Expenses',
    newExpense: 'New Expense',
    addExpense: 'Add Expense',
    addNewExpense: 'Add New Expense',
    expenseCategory: 'Expense Category',
    paidTo: 'Paid To',
    paidFrom: 'Paid From',
    expenseDate: 'Expense Date',
    recurring: 'Recurring',
    trackExpenses: 'Track and manage all your business expenses',
    totalExpenses: 'Total Expenses',
    thisMonth: 'This Month',
    change: 'Change',
    searchExpenses: 'Search expenses...',
    noExpensesFound: 'No expenses found.',
    expenseTitle: 'Expense Title',
    enterTitle: 'e.g., Office Rent',
    amount: 'Amount',
    date: 'Date',
    category: 'Category',
    selectCategory: 'Select category',
    salary: 'Salary',
    rent: 'Rent',
    utilities: 'Utilities',
    bankCharges: 'Bank Charges',
    paymentMode: 'Payment Mode',
    description: 'Description',
    addDetails: 'Add details...',
    saveExpense: 'Save Expense',
    expenseAdded: 'Expense added successfully!',
    expenseDeleted: 'Expense deleted',
    viewDetails: 'View expense details',
    downloading: 'Downloading...',
    all: 'All',
  },

  // Inventory
  inventory: {
    title: 'Inventory',
    items: 'Items',
    newItem: 'New Item',
    addItem: 'Add Item',
    addNewItem: 'Add New Item',
    itemCode: 'Item Code',
    category: 'Category',
    brand: 'Brand',
    stock: 'Stock',
    lowStockAlert: 'Low Stock Alert',
    sellingPrice: 'Selling Price',
    purchasePrice: 'Purchase Price',
    taxRate: 'Tax Rate',
    barcode: 'Barcode',
    stockIn: 'Stock In',
    stockOut: 'Stock Out',
    adjustment: 'Adjustment',
    inStock: 'In Stock',
    outOfStock: 'Out of Stock',
    basicInfo: 'Basic Information',
    itemName: 'Item Name',
    autoFillMagic: 'Auto-Fill Magic',
    startTyping: 'Start typing... (e.g., Amul Milk, Parle G, Maggi)',
    itemsFound: 'items found - Click to auto-fill',
    noSuggestions: 'No suggestions found. Fill details manually or try different name.',
    unitType: 'Unit Type',
    none: 'None',
    pieces: 'Pieces (PCS)',
    kilogram: 'Kilogram (KGS)',
    liter: 'Liter (LTRS)',
    meter: 'Meter (MTR)',
    box: 'Box',
    pack: 'Pack',
    set: 'Set',
    autoFillsUnit: '(Auto-fills unit conversion)',
    description: 'Description',
    aiSuggest: 'AI Suggest',
    briefDescription: 'Brief description of the item...',
    pricing: 'Pricing',
    retailSellingPrice: 'Retail Selling Price (MRP)',
    withoutGst: 'Without GST',
    withGst: 'With GST',
    basePrice: 'Base Price',
    customerPays: 'Customer Pays',
    basePurchase: 'Base Purchase',
    youPaidSupplier: 'You Paid Supplier',
    itemIsFor: 'This item is for:',
    sales: 'sales',
    purchase: 'purchase',
    both: 'both',
    profitMargin: 'Profit Margin',
    margin: 'margin',
    wholesalePrice: 'Wholesale Price',
    autoFilledMrp: '(Auto-filled: 30% of MRP)',
    taxCompliance: 'Tax & Compliance',
    intrastate: 'Intrastate',
    interstate: 'Interstate',
    hsnCode: 'HSN Code',
    enterHsnCode: 'Enter HSN code',
    stockDetails: 'Stock Details',
    openingStock: 'Opening Stock',
    lowStockAlertQty: 'Low Stock Alert',
    enterQty: 'Enter quantity',
    multiUnitConversion: 'Multi-Unit Conversion',
    enableMultiUnit: 'Enable Box/Case unit conversion',
    conversionSetup: 'Conversion Setup',
    pcsPerBox: 'Pcs per Box',
    boxPrices: 'Box Prices',
    boxSellingPrice: 'Box Selling Price',
    boxPurchasePrice: 'Box Purchase Price',
    profitPerBox: 'Profit/Box',
    addPhoto: 'Add Photo',
    tapToAddPhoto: 'Tap to add product photo',
    saveItem: 'Save Item',
    savingItem: 'Saving...',
    itemAdded: 'Item added successfully!',
    itemUpdated: 'Item updated successfully!',
    itemDeleted: 'Item deleted successfully!',
    enterItemName: 'Please enter item name',
    enterRetailPrice: 'Please enter retail price',
    // Additional Inventory translations
    inventoryManagement: 'Inventory Management',
    totalItems: 'Total Items',
    stockValue: 'Stock Value',
    lowStock: 'Low Stock',
    reorderRequired: 'Reorder required',
    immediateActionNeeded: 'Immediate action needed',
    acrossCategories: 'Across {count} categories',
    avgPerItem: 'Avg ?{amount}/item',
    searchByNameSku: 'Search by name or SKU...',
    allItems: 'All Items',
    loadingItems: 'Loading items...',
    noItemsFound: 'No items found matching your search',
    noItemsInInventory: 'No items in inventory. Add your first item to get started!',
    value: 'Value',
    buy: 'Buy',
    sell: 'Sell',
    stockLevel: 'Stock Level',
    reorderLevel: 'Reorder level: {count} units',
    gst: 'GST',
    viewItem: 'View Item',
    editItem: 'Edit Item',
    deleteItem: 'Delete Item',
    recentStockMovements: 'Recent Stock Movements',
    type: 'Type',
    item: 'Item',
    quantity: 'Quantity',
    reference: 'Reference',
    date: 'Date',
    by: 'By',
    units: 'units',
    stockManagement: 'Stock Management',
    alertBelowQty: 'Alert when stock falls below this quantity',
    enable: 'Enable',
    multiUnitInfo: 'Enable if you purchase in larger units (e.g., Box) but sell in smaller units (e.g., Pieces)',
    baseUnitSale: 'Base Unit (Sale)',
    purchaseUnitLabel: 'Purchase Unit',
    piecesUnit: 'Pieces (Pcs)',
    kilogramUnit: 'Kilogram (Kg)',
    literUnit: 'Liter (Ltr)',
    meterUnit: 'Meter (Mtr)',
    unitLabel: 'Unit',
    boxUnit: 'Box',
    cartonUnit: 'Carton',
    packUnit: 'Pack',
    dozenUnit: 'Dozen',
    caseUnit: 'Case',
    bundleUnit: 'Bundle',
    boxPricingCalculator: 'Box/Pack Pricing Calculator',
    autoLabel: '100% Auto',
    basedOnPrices: 'Based on your Retail Price (?{retail}) and Purchase Price (?{purchase}) per piece:',
    sellingPriceMrp: '{unit} Selling Price (MRP)',
    unitPurchasePrice: '{unit} Purchase Price',
    profitPer: 'Profit per {unit}',
    profitMarginPercent: 'Profit Margin %',
    editSyncNote: 'Edit either piece prices or box prices - both sync automatically!',
    optionalDetails: 'Optional Details',
    brandName: 'Brand Name',
    brandPlaceholder: 'e.g., Cello, Parker, HP',
    barcodeSku: 'Barcode/SKU',
    barcodeSkuNumber: 'Barcode/SKU Number',
    tapCameraToScan: 'Tap camera to scan',
    typeOrUseScanner: 'Type or use scanner',
    tapOrTypeBarcode: 'Tap camera or type barcode',
    enterOrScanBarcode: 'Enter or scan barcode',
    scan: 'Scan',
    cancel: 'Cancel',
    aiSuggestions: 'AI Suggestions',
    clickToUse: 'Click to use',
    viewSuggestions: 'View {count} suggestion(s)',
    autoFilledFromCategory: '(Auto-filled from Category)',
    hsnApplied: 'HSN Code {code} applied with {rate}% GST',
    commonCategories: 'Common Categories',
    foodBeverages: 'Food & Beverages',
    personalCare: 'Personal Care',
    stationeryOffice: 'Stationery & Office',
    electronicsOthers: 'Electronics & Others',
    health: 'Health',
    general: 'General',
    // Delete confirmation
    confirmDelete: 'Confirm Delete',
    deleteConfirmMsg: 'Are you sure you want to delete this item?',
    thisActionCannot: 'This action cannot be undone.',
    // View modal
    itemDetails: 'Item Details',
    // Categories
    biscuits: 'Biscuits',
    chips: 'Chips',
    chocolate: 'Chocolate',
    soap: 'Soap',
    softDrinks: 'Soft Drinks',
    noodles: 'Noodles',
    juice: 'Juice',
    waterBottles: 'Water Bottles',
    pasta: 'Pasta',
    rice: 'Rice',
    oil: 'Oil',
    milk: 'Milk',
    tea: 'Tea',
    coffee: 'Coffee',
    shampoo: 'Shampoo',
    toothpaste: 'Toothpaste',
    cream: 'Cream',
    detergent: 'Detergent',
    sanitizer: 'Sanitizer',
    stationery: 'Stationery',
    pens: 'Pens',
    notebooks: 'Notebooks',
    pencils: 'Pencils',
    batteries: 'Batteries',
    bulbs: 'Bulbs',
    electronics: 'Electronics',
    furniture: 'Furniture',
    tablets: 'Tablets',
    syrup: 'Syrup',
    other: 'Other',
  },

  // More/Others page
  more: {
    title: 'More Features',
    subtitle: 'Additional powerful tools for your business',
    quickActions: 'Quick Actions',
    allFeatures: 'All Features',
    // Modules
    onlineStore: 'Online Store',
    onlineStoreDesc: 'Your e-commerce website & storefront',
    deliveryChallan: 'Delivery Challan',
    deliveryChallanDesc: 'Create delivery challans without invoice',
    purchaseOrders: 'Purchase Orders',
    purchaseOrdersDesc: 'Manage purchase orders to suppliers',
    creditDebitNotes: 'Credit/Debit Notes',
    creditDebitNotesDesc: 'Issue credit and debit notes',
    paymentIn: 'Payment In',
    paymentInDesc: 'Record payments received',
    paymentOut: 'Payment Out',
    paymentOutDesc: 'Record payments made',
    ewayBill: 'E-Way Bill',
    ewayBillDesc: 'Generate E-Way bills for transportation',
    barcodeScanner: 'Barcode Scanner',
    barcodeScannerDesc: 'Scan barcodes for quick billing',
    barcodeGenerator: 'Barcode Generator',
    barcodeGeneratorDesc: 'Generate barcodes for product labels',
    selectProduct: 'Select Product',
    searchProductBarcode: 'Search by product name or barcode...',
    barcode: 'Barcode',
    price: 'Price',
    quantity: 'Quantity',
    numberOfLabels: 'Number of Labels',
    labelSize: 'Label Size',
    small: 'Small',
    medium: 'Medium',
    large: 'Large',
    showProductName: 'Show Product Name',
    showPrice: 'Show Price',
    addToPrintQueue: 'Add to Print Queue',
    addedToPrintQueue: 'Added to print queue',
    printQueue: 'Print Queue',
    labels: 'labels',
    clearAll: 'Clear All',
    printBarcodes: 'Print Barcodes',
    scanBarcode: 'Scan Barcode',
    addNewProduct: 'Add New Product',
    labelOptions: 'Label Options',
    labelSizeHint: 'Standard label rolls: 38×25mm (small), 50×25mm (medium), 75×38mm (large)',
    printingInfo: 'Printing Information',
    labelSizeSelected: 'Label Size',
    totalLabels: 'Total Labels',
    barcodeFormat: 'Barcode Format',
    previewLabels: 'Preview Labels',
    printNow: 'Print Now',
    printingTips: 'Printing Tips',
    qrCodeScanner: 'QR Code Scanner',
    qrCodeScannerDesc: 'Scan QR codes for payments',
    priceLists: 'Price Lists',
    priceListsDesc: 'Manage multiple price lists',
    staffAttendance: 'Staff Attendance',
    staffAttendanceDesc: 'Track employee attendance',
    staffMaster: 'Staff Master',
    staffMasterDesc: 'Manage staff members & codes',
    salaryManagement: 'Salary Management',
    salaryManagementDesc: 'Manage staff salaries & payroll',
    proformaInvoice: 'Proforma Invoice',
    proformaInvoiceDesc: 'Create proforma invoices',
    serialNumberTracking: 'Serial Number Tracking',
    serialNumberTrackingDesc: 'Track items by serial numbers',
    notes: 'Notes',
    notesDesc: 'Add notes for tasks & parties',
    schemes: 'Schemes',
    schemesDesc: 'Create promotional schemes',
    discountManagement: 'Discount Management',
    discountManagementDesc: 'Manage various discount types',
    ledgerReport: 'Ledger Report',
    ledgerReportDesc: 'View detailed ledger accounts',
    multipleLocations: 'Multiple Locations',
    multipleLocationsDesc: 'Manage multiple business locations',
    whatsappIntegration: 'WhatsApp Integration',
    whatsappIntegrationDesc: 'Send invoices via WhatsApp',
    upiPaymentLinks: 'UPI Payment Links',
    upiPaymentLinksDesc: 'Generate UPI payment links',
    // Stats
    totalCreated: 'Total Created',
    total: 'Total',
    sent: 'Sent',
    accepted: 'Accepted',
    pending: 'Pending',
    inTransit: 'In Transit',
    delivered: 'Delivered',
    totalOrders: 'Total Orders',
    revenue: 'Revenue',
    features: 'Features',
    productCatalog: 'Product Catalog',
    shoppingCart: 'Shopping Cart',
    paymentGateway: 'Payment Gateway',
    orderManagement: 'Order Management',
    customDomain: 'Custom Domain',
    mobileResponsive: 'Mobile Responsive',
    // Actions
    create: 'Create',
    createNew: 'Create New',
    edit: 'Edit',
    view: 'View',
    delete: 'Delete',
    markInTransit: 'Mark In Transit',
    markDelivered: 'Mark Delivered',
    // Forms
    searchOrTypeParty: 'Search or type party name...',
    searchItems: 'Search items from inventory...',
    vehicleNumber: 'Vehicle Number',
    transporterName: 'Transporter Name',
    driverName: 'Driver Name',
    remarks: 'Remarks',
    additionalNotes: 'Additional notes...',
    validFor: 'Valid For',
    days: 'Days',
    selectPurpose: 'Select Purpose',
    // Proforma
    proformaInvoiceTitle: 'Proforma Invoice',
    notForTaxPurposes: 'Not for Tax Purposes',
    searchCustomer: 'Search or type customer name...',
    searchItemsHsn: 'Search items by name or HSN code...',
    searchAndAddItems: 'Search and add items above',
    // Delivery Challan
    deliveryChallanTitle: 'Delivery Challan',
    selectParty: 'Select Party',
    searchAndAddDeliver: 'Search and add items to deliver',
    // Table headers
    itemCol: 'Item',
    qtyCol: 'Qty',
    unitCol: 'Unit',
    rateCol: 'Rate',
    discountCol: 'Discount',
    amountCol: 'Amount',
    // Unit options
    pcsUnit: 'PCS',
    kgsUnit: 'KGS',
    ltrsUnit: 'LTRS',
    mtrUnit: 'MTR',
    boxUnitShort: 'BOX',
    setUnit: 'SET',
    // Messages
    noProformaInvoices: 'No proforma invoices yet',
    noDeliveryChallans: 'No delivery challans yet',
    createPurchaseOrder: 'Create new purchase order...',
    recordPaymentReceived: 'Recording payment received...',
    recordPaymentMade: 'Recording payment made...',
    createPriceList: 'Create new price list...',
    generateEwayBill: 'Generate E-Way bill...',
    scanProductBarcodes: 'Scan Product Barcodes',
    scanQrCodes: 'Scan QR Codes',
    upiPayments: 'UPI Payments',
    scansToday: 'Scans Today',
    successRate: 'Success Rate',
    totalGenerated: 'Total Generated',
    active: 'Active',
    startScanning: 'Start Scanning',
    openScanner: 'Open Scanner',
    // Upgrade
    upgradeRequired: 'Upgrade Required',
    availableInGoldPlan: 'Available in Gold Plan',
    // Challan purposes
    jobWork: 'Job Work',
    supplyOnApproval: 'Supply on Approval',
    exhibition: 'Exhibition',
    lineRejection: 'Line Rejection',
    sampleDelivery: 'Sample Delivery',
    warrantyReplacement: 'Warranty Replacement',
    repairService: 'Repair/Service',
    returnable: 'Returnable',
    // Badges
    badgePopular: 'Popular',
    badgeEssential: 'Essential',
    badgeNew: 'New',
    badgeGst: 'GST',
    // Form labels
    partyCustomer: 'Party / Customer',
    purpose: 'Purpose',
    reference: 'Reference (PO Number, Order ID, etc.)',
    addItems: 'Add Items',
    selectCustomer: 'Select Customer',
    termsConditions: 'Terms & Conditions',
    advanceReceived: 'Advance Received:',
    noMatchNewCustomer: 'No match. Type to use as new customer.',
    noGstin: 'No GSTIN',
    createDeliveryChallan: 'Create Delivery Challan',
    createProformaInvoice: 'Create Proforma Invoice',
    goodsDeliveryWithoutInvoice: 'Goods Delivery without Invoice (GST Rule 55)',
    taxableAmount: 'Taxable Amount',
    gst: 'GST',
    grandTotal: 'Grand Total',
  },

  // Reports
  reports: {
    title: 'Reports',
    all: 'All',
    salesReport: 'Sales Report',
    purchaseReport: 'Purchase Report',
    profitLoss: 'Profit & Loss',
    gstReport: 'GST Report',
    stockReport: 'Stock Report',
    partyReport: 'Party Report',
    dayBook: 'Day Book',
    cashFlow: 'Cash Flow',
    taxSummary: 'Tax Summary',
    gstr1: 'GSTR-1',
    gstr3b: 'GSTR-3B',
    businessReports: 'Business Reports',
    comprehensiveAnalytics: 'Comprehensive analytics and insights',
    downloadJSON: 'Download JSON',
    downloadExcel: 'Download Excel',
    downloadPDF: 'Download PDF',
    dateRange: 'Date Range',
    reportCategories: 'Report Categories',
    selectReportCategory: 'Select a Report Category',
    chooseCategory: 'Choose a category from the left to view available reports',
    salesReports: 'Sales Reports',
    purchaseReports: 'Purchase Reports',
    inventoryReports: 'Inventory Reports',
    financialReports: 'Financial Reports',
    partyReports: 'Party Reports',
    gstReports: 'GST Reports',
    salesSummary: 'Sales Summary',
    overallSalesPerformance: 'Overall sales performance',
    salesByCustomer: 'Sales by Customer',
    customerWiseSales: 'Customer-wise sales breakdown',
    salesByItem: 'Sales by Item',
    itemWiseSales: 'Item-wise sales analysis',
    invoiceReport: 'Invoice Report',
    detailedInvoiceListing: 'Detailed invoice listing',
    salesTaxReport: 'Sales Tax Report',
    taxCollectedOnSales: 'Tax collected on sales',
    salesReturnReport: 'Sales Return Report',
    returnsAndCredits: 'Returns and credits',
    purchaseSummary: 'Purchase Summary',
    overallPurchaseAnalysis: 'Overall purchase analysis',
    purchaseBySupplier: 'Purchase by Supplier',
    supplierWisePurchases: 'Supplier-wise purchases',
    purchaseByItem: 'Purchase by Item',
    itemWisePurchaseDetails: 'Item-wise purchase details',
    purchaseOrderReport: 'Purchase Order Report',
    poTrackingAndStatus: 'PO tracking and status',
    purchaseTaxReport: 'Purchase Tax Report',
    taxPaidOnPurchases: 'Tax paid on purchases',
    stockSummary: 'Stock Summary',
    currentStockLevels: 'Current stock levels',
    stockDetailReport: 'Stock Detail Report',
    itemWiseStockDetails: 'Item-wise stock details',
    lowStockAlert: 'Low Stock Alert',
    itemsBelowMinimumLevel: 'Items below minimum level',
    stockMovement: 'Stock Movement',
    stockInOutAnalysis: 'Stock in/out analysis',
    deadStockReport: 'Dead Stock Report',
    nonMovingInventory: 'Non-moving inventory',
    stockValuation: 'Stock Valuation',
    inventoryValueReport: 'Inventory value report',
    balanceSheet: 'Balance Sheet',
    assetsAndLiabilities: 'Assets and liabilities',
    cashFlowStatement: 'Cash Flow Statement',
    cashMovementAnalysis: 'Cash movement analysis',
    trialBalance: 'Trial Balance',
    accountingTrialBalance: 'Accounting trial balance',
    generalLedger: 'General Ledger',
    completeLedgerReport: 'Complete ledger report',
    accountsReceivable: 'Accounts Receivable',
    moneyToBeReceived: 'Money to be received',
    accountsPayable: 'Accounts Payable',
    moneyToBePaid: 'Money to be paid',
    partyLedger: 'Party Ledger',
    individualPartyStatements: 'Individual party statements',
    agingReport: 'Aging Report',
    outstandingAgingAnalysis: 'Outstanding aging analysis',
    partyWiseProfit: 'Party-wise Profit',
    profitByCustomer: 'Profit by customer',
    outwardSuppliesReturn: 'Outward supplies return',
    inwardSuppliesReturn: 'Inward supplies return',
    summaryReturn: 'Summary return',
    gstSummary: 'GST Summary',
    taxSummaryReport: 'Tax summary report',
    hsnSummary: 'HSN Summary',
    hsnWiseSummary: 'HSN-wise summary',
    totalSales: 'Total Sales',
    totalInvoices: 'Total Invoices',
    avgInvoiceValue: 'Avg Invoice Value',
    netProfit: 'Net Profit',
    receivables: 'Receivables',
    stockValue: 'Stock Value',
    overdue: 'Overdue',
    lowStock: 'Low Stock',
    thisMonth: 'This Month',
    revenue: 'Revenue',
    salesRevenue: 'Sales Revenue',
    otherIncome: 'Other Income',
    totalRevenue: 'Total Revenue',
    expenses: 'Expenses',
    costOfGoodsSold: 'Cost of Goods Sold',
    operatingExpenses: 'Operating Expenses',
    salaries: 'Salaries',
    totalExpenses: 'Total Expenses',
    profitMargin: 'Profit Margin',
    currentStock: 'Current Stock',
    minStock: 'Min Stock',
    value: 'Value',
    healthy: 'Healthy',
    critical: 'Critical',
    criticalLow: 'Critical Low',
    totalOutstanding: 'Total Outstanding',
    overdueAmount: 'Overdue Amount',
    totalReceivables: 'Total Receivables',
    totalOverdue: 'Total Overdue',
    outputTax: 'Output Tax',
    inputTax: 'Input Tax',
    netGstPayable: 'Net GST Payable',
    outputTaxMinusInputTax: 'Output Tax - Input Tax',
    topCustomers: 'Top Customers',
    top5Customers: 'Top 5 Customers',
    reports: 'reports',
    // ReportsNew page translations
    everyDay: 'Every Day',
    everyDayReports: 'Every Day Reports',
    essentialDailyReports: 'Essential daily reports for shop owners - Check these every day to stay on top of your business',
    whatHappenedToday: 'What happened today',
    billingStaffReport: 'Billing Staff Report',
    billingStaffReportDesc: 'Bills created by each billing staff with sales staff split',
    billingStaff: 'Billing Staff',
    salesStaff: 'Sales Staff',
    totalBills: 'Total Bills',
    profitLossToday: 'Profit & Loss (Today)',
    didIEarnOrLose: 'Did I earn or lose today?',
    cashBankBalance: 'Cash in Hand / Bank Balance',
    doIHaveMoney: 'Do I have money to pay suppliers?',
    pendingToReceive: 'Pending Payments to Receive',
    whoOwesMeMoney: 'Who owes me money?',
    pendingToPay: 'Pending Payments to Pay',
    whoDoIOwe: 'Who do I need to pay?',
    stockSummaryReport: 'Stock Summary',
    whatNeedsReorder: 'What needs to be reordered?',
    transactions: 'Transactions',
    transactionReports: 'Transaction Reports',
    detailedTransactions: 'Detailed transaction records',
    purchaseRegister: 'Purchase Register',
    allPurchases: 'All purchase transactions',
    salesRegister: 'Sales Register',
    allSales: 'All sales transactions',
    stockReports: 'Stock Reports',
    inventoryManagement: 'Inventory management and analysis',
    stockAlert: 'Stock Alert',
    lowStockItems: 'Items running low on stock',
    fastMovingItems: 'Fast Moving Items',
    bestSellers: 'Your best sellers',
    slowMovingItems: 'Slow Moving Items',
    deadStock: 'Dead stock identification',
    partyReportsTitle: 'Party Reports',
    partyAnalysis: 'Customer and supplier analysis',
    partyWisePL: 'Party-wise P&L',
    profitByParty: 'Profit/loss by each party',
    itemWisePL: 'Item-wise P&L',
    profitByItem: 'Profit/loss by each item',
    billWiseProfit: 'Bill-wise Profit',
    profitOnEachBill: 'Profit on each bill',
    discountReport: 'Discount Report',
    discountsGiven: 'Discounts given analysis',
    gstReportsTitle: 'GST Reports',
    gstCompliance: 'GST compliance and filing reports',
    hsnSummaryReport: 'HSN Summary',
    hsnWiseReport: 'HSN-wise tax summary',
    loadingReport: 'Loading report...',
    allTime: 'All Time',
    // Day Book specific translations
    dayBookTitle: 'Day Book',
    salesLabel: 'Sales',
    purchasesLabel: 'Purchases',
    netCashFlow: 'Net Cash Flow',
    invoiceHash: 'Invoice #',
    type: 'Type',
    party: 'Party',
    sale: 'SALE',
    purchase: 'PURCHASE',
    bills: 'bills',
    // P&L Statement translations
    profitLossStatement: 'Profit & Loss Statement',
    period: 'Period',
    partialPeriodDetected: 'Partial Period Detected',
    daysOf: 'of',
    days: 'days',
    recurringExpensesProrated: 'Recurring expenses have been automatically prorated for this partial period:',
    fullMonth: 'full month',
    onlyDaysWorth: "Only {days} days' worth of monthly expenses are counted.",
    preventsLosses: 'This prevents misleading losses in partial-month reports.',
    expensesMayLookHigh: 'Some expenses may look high for just {days} days.',
    markRecurringTip: 'Tip: Mark recurring expenses (Rent, Salary) as "Monthly Recurring" for automatic daily proration.',
    revenueSales: 'Revenue (Sales)',
    grossProfit: 'Gross Profit',
    rent: 'Rent',
    utilities: 'Utilities',
    marketing: 'Marketing',
    otherExpenses: 'Other Expenses',
    totalOperatingExpenses: 'Total Operating Expenses',
    netProfitLoss: 'Net Profit / Loss',
    profitLabel: 'Profit',
    lossLabel: 'Loss',
  },

  // Banking
  banking: {
    title: 'Banking',
    accounts: 'Accounts',
    newAccount: 'New Account',
    accountName: 'Account Name',
    accountNumber: 'Account Number',
    bankName: 'Bank Name',
    ifsc: 'IFSC Code',
    branch: 'Branch',
    balance: 'Balance',
    transactions: 'Transactions',
    deposit: 'Deposit',
    withdrawal: 'Withdrawal',
    transfer: 'Transfer',
    bankingAndFinance: 'Banking & Finance',
    manageAccountsCashCheques: 'Manage accounts, cash, cheques & loans',
    addAccount: 'Add Account',
    availableBalance: 'Available Balance',
    bankPlusCashMinusPending: 'Bank + Cash - Pending Cheques',
    cashInHand: 'Cash in Hand',
    availableCash: 'Available Cash',
    pendingCheques: 'Pending Cheques',
    cheques: 'cheques',
    netWorth: 'Net Worth',
    assetsMinusLoans: 'Assets - Loans',
    active: 'active',
    overview: 'Overview',
    razorpay: 'Razorpay',
    loans: 'Loans',
    bankAccounts: 'Bank Accounts',
    add: '+ Add',
    cashIn: 'Cash In',
    cashOut: 'Cash Out',
    recentTransactions: 'Recent Transactions',
    chequeManagement: 'Cheque Management',
    addCheque: 'Add Cheque',
    chequeNo: 'Cheque No.',
    party: 'Party',
    amount: 'Amount',
    date: 'Date',
    depositBank: 'Deposit Bank',
    status: 'Status',
    actions: 'Actions',
    cleared: 'Cleared',
    pending: 'Pending',
    bounced: 'Bounced',
    viewDetails: 'View details',
    editCheque: 'Edit cheque',
    deleteCheque: 'Delete cheque',
    setupRazorpay: 'Set up Razorpay Payments',
    acceptPaymentsOnline: 'Accept UPI, Cards, Net Banking & Wallets directly from your invoices',
    configureRazorpay: 'Configure Razorpay',
    totalCollected: 'Total Collected',
    payments: 'payments',
    linksActive: 'links active',
    successRate: 'Success Rate',
    failed: 'failed',
    totalLinks: 'Total Links',
    allTime: 'All time',
    paymentLinksAndTransactions: 'Payment Links & Transactions',
    noPaymentLinksYet: 'No payment links yet',
    generatePaymentLinks: 'Generate payment links from your invoices to collect payments online',
    invoice: 'Invoice',
    customer: 'Customer',
    copyLink: 'Copy Link',
    openLink: 'Open Link',
    sendViaWhatsApp: 'Send via WhatsApp',
    paid: 'Paid',
    processing: 'Processing',
    refunded: 'Refunded',
    loanAccounts: 'Loan Accounts',
    addLoan: 'Add Loan',
    principalAmount: 'Principal Amount',
    outstanding: 'Outstanding',
    monthlyEmi: 'Monthly EMI',
    nextDueDate: 'Next Due Date',
    paidPercent: 'Paid',
    payEmi: 'Pay EMI',
    searchTransactions: 'Search transactions...',
    addBankAccount: 'Add Bank Account',
    accountType: 'Account Type',
    currentAccount: 'Current Account',
    savingsAccount: 'Savings Account',
    openingBalance: 'Opening Balance',
    cancel: 'Cancel',
    chequeNumber: 'Cheque Number',
    partyName: 'Party Name',
    typeToSearchParties: 'Type to search parties...',
    depositIntoBank: 'Deposit into Bank',
    selectBankAccount: 'Select Bank Account',
    chequeAmountCredited: 'The cheque amount will be credited to this account when cleared',
    chequeDate: 'Cheque Date',
    updateCheque: 'Update Cheque',
    amountRs: 'Amount (₹)',
    enterAmount: 'Enter amount',
    description: 'Description',
    addCash: 'Add Cash',
    withdrawCash: 'Withdraw Cash',
    notSet: 'Not set',
  },

  // Settings
  settings: {
    title: 'Settings',
    companyInfo: 'Company Information',
    companyName: 'Company Name',
    companyLogo: 'Company Logo',
    companyGstin: 'Company GSTIN',
    companyAddress: 'Company Address',
    companyPhone: 'Company Phone',
    companyEmail: 'Company Email',
    invoiceSettings: 'Invoice Settings',
    invoicePrefix: 'Invoice Prefix',
    invoiceStartNumber: 'Invoice Start Number',
    defaultTaxRate: 'Default Tax Rate',
    taxSettings: 'Tax Settings',
    paymentSettings: 'Payment Settings',
    printSettings: 'Print Settings',
    notificationSettings: 'Notification Settings',
    language: 'Language',
    theme: 'Theme',
    darkMode: 'Dark Mode',
    lightMode: 'Light Mode',
    backup: 'Backup',
    restore: 'Restore',
    clearData: 'Clear Data',
    about: 'About',
    help: 'Help',
    support: 'Support',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    selectLanguage: 'Select Language',
    english: 'English',
    tamil: 'தமிழ்',
    configurePreferences: 'Configure your business preferences',
    general: 'General',
    languageLabel: 'Language / மொழி',
    razorpayPayments: 'Razorpay Payments',
    offlineAndSync: 'Offline & Sync',
    backupAndExport: 'Backup & Export',
    transaction: 'Transaction',
    invoicePrint: 'Invoice Print',
    invoiceTable: 'Invoice Table',
    taxesAndGst: 'Taxes & GST',
    userManagement: 'User Management',
    transactionalSms: 'Transactional SMS',
    reminders: 'Reminders',
    partySettings: 'Party Settings',
    itemSettings: 'Item Settings',
    utilities: 'Utilities',
    developerTools: 'Developer Tools',
    generalSettings: 'General Settings',
    businessName: 'Business Name',
    financialYear: 'Financial Year',
    currency: 'Currency',
    dateFormat: 'Date Format',
    timeFormat: 'Time Format',
    hour12: '12 Hour',
    hour24: '24 Hour',
    appearance: 'Appearance',
    saveChanges: 'Save Changes',
    gstin: 'GSTIN',
    panNumber: 'PAN Number',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    updateCompanyInfo: 'Update Company Info',
    razorpayPaymentGateway: 'Razorpay Payment Gateway',
    acceptPaymentsVia: 'Accept payments via UPI, Cards, Net Banking, and Wallets',
    connected: 'Connected',
    quickSetupGuide: 'Quick Setup Guide',
    signUpAt: 'Sign up at',
    goToAccountSettings: 'Go to Account & Settings → API Keys',
    generateTestOrLiveKeys: 'Generate Test or Live keys',
    pasteKeyIdAndSecret: 'Paste Key ID and Secret below',
    apiCredentials: 'API Credentials',
    keyId: 'Key ID',
    keySecret: 'Key Secret',
    keepSecretSecure: 'Keep this secret secure. Never share it publicly.',
    testMode: 'Test Mode',
    liveMode: 'Live Mode',
    keysValidated: 'Keys validated',
    invalidKeys: 'Invalid keys',
    paymentMethods: 'Payment Methods',
    validateAndSave: 'Validate & Save',
    validating: 'Validating...',
    offlineSyncSettings: 'Offline & Sync Settings',
    enableOfflineMode: 'Enable Offline Mode',
    autoSyncOnReconnect: 'Auto-sync on Reconnect',
    cacheDataForOffline: 'Cache Data for Offline Use',
    caching: 'Caching...',
    cacheAllData: 'Cache All Data',
    clearOfflineCache: 'Clear Offline Cache',
    cachedItems: 'Cached Items',
    cachedParties: 'Cached Parties',
    cachedInvoices: 'Cached Invoices',
    pendingSync: 'Pending Sync',
    lastSync: 'Last Sync',
    never: 'Never',
    backupAndExportData: 'Backup & Export Data',
    exportCompleteData: 'Export Complete Data',
    exportInvoicesOnly: 'Export Invoices Only',
    exportPartiesOnly: 'Export Parties Only',
    exportItemsOnly: 'Export Items Only',
    createBackup: 'Create Backup',
    userManagementTitle: 'User Management',
    users: 'Users',
    permissions: 'Permissions',
    addUser: 'Add User',
    loadingUsers: 'Loading users...',
    noUsersFound: 'No users found',
    name: 'Name',
    role: 'Role',
    status: 'Status',
    admin: 'Admin',
    manager: 'Manager',
    cashier: 'Cashier',
    active: 'Active',
    inactive: 'Inactive',
    changeRole: 'Change Role',
    deactivate: 'Deactivate',
    activate: 'Activate',
    deleteUser: 'Delete User',
    addNewUser: 'Add New User',
    fullName: 'Full Name',
    emailAddress: 'Email Address',
    password: 'Password',
    selectRole: 'Select Role',
    creating: 'Creating...',
    createUser: 'Create User',
    cancel: 'Cancel',
    pagePermissions: 'Page Permissions',
    selectUserToManage: 'Select a user to manage their page permissions',
    resetToDefaults: 'Reset to Defaults',
    savePermissions: 'Save Permissions',
    saving: 'Saving...',
    developerToolsTitle: 'Developer Tools',
    generateDummyData: 'Generate Dummy Data',
    clearAllData: 'Clear All Data',
    generateSampleData: 'Generate sample data for testing',
    generating: 'Generating...',
    generate: 'Generate',
    warningClearData: 'This will permanently delete ALL data',
  },

  // Payments
  payments: {
    paymentType: 'Payment Type',
    paymentMethod: 'Payment Method',
    paymentDate: 'Payment Date',
    referenceNumber: 'Reference Number',
    transactionId: 'Transaction ID',
    addPayment: 'Add Payment',
    paymentHistory: 'Payment History',
    reversePayment: 'Reverse Payment',
    resetToPending: 'Reset to Pending',
  },

  // Messages
  messages: {
    saveSuccess: 'Saved successfully',
    deleteSuccess: 'Deleted successfully',
    updateSuccess: 'Updated successfully',
    errorOccurred: 'An error occurred',
    confirmDelete: 'Are you sure you want to delete?',
    confirmAction: 'Are you sure?',
    noItemsFound: 'No items found',
    noCustomersFound: 'No customers found',
    pleaseSelectCustomer: 'Please select a customer',
    pleaseAddItems: 'Please add at least one item',
    invalidAmount: 'Invalid amount',
    insufficientStock: 'Insufficient stock',
    paymentRecorded: 'Payment recorded successfully',
    invoiceCreated: 'Invoice created successfully',
    invoiceSaved: 'Invoice saved successfully',
  },

  // Invoice Preview
  invoicePreview: {
    taxInvoice: 'TAX INVOICE',
    quotation: 'QUOTATION',
    proformaInvoice: 'PROFORMA INVOICE',
    deliveryChallan: 'DELIVERY CHALLAN',
    supplierDetails: 'SUPPLIER DETAILS',
    recipientDetails: 'RECIPIENT (BILL TO)',
    taxDetails: 'Tax Details',
    amountInWords: 'AMOUNT IN WORDS',
    bankDetails: 'BANK DETAILS',
    termsAndConditions: 'Terms and Conditions',
    authorizedSignatory: 'Authorized Signatory',
    thankYou: 'Thank you for your business!',
    grandTotal: 'Grand Total',
    taxableAmount: 'Taxable Amount',
  },

  // Quick Actions
  quickActions: {
    newInvoice: 'New Invoice',
    newPurchase: 'New Purchase',
    newQuote: 'New Quote',
    newParty: 'New Party',
    newExpense: 'New Expense',
    newItem: 'New Item',
    payIn: 'Pay In',
    payOut: 'Pay Out',
  },

  // Units
  units: {
    pcs: 'PCS',
    kgs: 'KGS',
    ltr: 'LTR',
    mtr: 'MTR',
    box: 'BOX',
    pck: 'PCK',
    set: 'SET',
    nos: 'NOS',
    bag: 'BAG',
    roll: 'ROLL',
  },

  // Months
  months: {
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
  },

  // Days
  days: {
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
  },
}

export default en


